import React, { useState } from 'react'
import { Box } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import CancelIcon from '@material-ui/icons/Cancel'
import DeleteIcon from '@material-ui/icons/DeleteOutlined'
import EditIcon from '@material-ui/icons/EditOutlined'
import NoteAltIcon from '@material-ui/icons/NoteOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Menu from '@material-ui/core/Menu'
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined'
import BookingActionMenuItem from 'src/views/freightbooking/components/BookingActionMenuItem'
import CalistaUiComponentTranslationText from 'src/views/common/CalistaUiComponentTranslationText'
import ComplianceTranslationText from '../ComplianceTranslationText'
import SIUtils from 'src/views/shippinginstruction/shared/Utils'
import PrintIcon from '@material-ui/icons/Print'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { faRetweetAlt, faEnvelope, faDownload } from '@fortawesome/pro-light-svg-icons'

const copyIcon = <FileCopyIcon fontSize='small' />
const cancelIcon = <CancelIcon fontSize='small' />
const deleteIcon = <DeleteIcon fontSize='small' />
const amendIcon = <EditIcon fontSize='small' />
const createPermitIcon = <NoteAltIcon fontSize='small' />
const approveIcon = <CheckCircleOutlineIcon fontSize='small' />
const rejectIcon = <FontAwesomeIcon icon={faRetweetAlt} fontSize='small' />
const downloadIcon = <FontAwesomeIcon icon={faDownload} fontSize='small' />
const printIcon = <PrintIcon fontSize='small' />
const surrenderBLIcon = <EventAvailableIcon fontSize='small' />
const enquireIcon = <FontAwesomeIcon icon={faEnvelope} fontSize='small' />

const ActionMenuSIList = (props) => {
  const { actions, eventHandlers, page } = props
  const [anchorEl, setAnchorEl] = useState(null)
  const translationObject = CalistaUiComponentTranslationText()
  const complianceTranslationText = ComplianceTranslationText()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const printBLinList = () => {
    setAnchorEl(null)
    eventHandlers.printBL()
  }

  return (
    <Box>
      <IconButton
        aria-label='more'
        aria-controls='long-menu'
        aria-haspopup='true'
        onClick={handleClick}
        className={'moreMenuBtn'}
      >
        <MoreHorizOutlinedIcon />
      </IconButton>
      {actions.length > 0 && (
        <Menu
          id='simple-menu'
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {actions.map((action, idx) => {
            switch (action) {
              case SIUtils.Action.printbl:
                return (
                  <BookingActionMenuItem
                    icon={printIcon}
                    action={printBLinList}
                    label={complianceTranslationText.printBl}
                  />
                )

              case SIUtils.Action.approve:
                return (
                  <BookingActionMenuItem
                    icon={approveIcon}
                    action={eventHandlers.approveSI}
                    label={complianceTranslationText.approveSI}
                  />
                )

              case SIUtils.Action.reject:
                return (
                  <BookingActionMenuItem
                    icon={rejectIcon}
                    action={eventHandlers.rejectSI}
                    label={complianceTranslationText.rejectSI}
                  />
                )

              case SIUtils.Action.surrenderbl:
                return (
                  <BookingActionMenuItem
                    icon={surrenderBLIcon}
                    action={eventHandlers.surrenderBL}
                    label={complianceTranslationText.surrenderBl}
                  />
                )

              case SIUtils.Action.copy:
                return (
                  <BookingActionMenuItem
                    icon={copyIcon}
                    label={translationObject.copy}
                    action={eventHandlers.copySI}
                  />
                )
              case SIUtils.Action.cancel:
                return (
                  <BookingActionMenuItem
                    icon={cancelIcon}
                    action={eventHandlers.cancelSI}
                    label={translationObject.cancel}
                  />
                )
              case SIUtils.Action.delete:
                return (
                  <BookingActionMenuItem
                    icon={deleteIcon}
                    action={eventHandlers.deleteSI}
                    label={translationObject.deleteText}
                  />
                )

              case SIUtils.Action.edit:
                return (
                  <BookingActionMenuItem
                    icon={amendIcon}
                    action={eventHandlers.editSIg(page)}
                    label={translationObject.edit}
                  />
                )

              case SIUtils.Action.createPermit:
                return (
                  <BookingActionMenuItem
                    icon={createPermitIcon}
                    action={eventHandlers.createPermit(page)}
                    label={translationObject.createPermit}
                  />
                )

              case SIUtils.Action.manage:
                return (
                  <BookingActionMenuItem
                    icon={amendIcon}
                    action={eventHandlers.manageSI(page)}
                    label={translationObject.manage}
                  />
                )

              case SIUtils.Action.update:
                if (props.si.complianceStatus === 5401 || props.si.complianceStatus === 5402 || props.si.complianceStatus === 5404 || props.si.complianceStatus === 5406 || (props.si.enquiredStatus && props.si.complianceStatus !== 5401)) {
                  return (
                    <BookingActionMenuItem
                      icon={amendIcon}
                      action={eventHandlers.updatePermit}
                      label={translationObject.update}
                    />
                  )
                }
              break

              case SIUtils.Action.enquireStatus:
                return (
                  <BookingActionMenuItem
                    icon={enquireIcon}
                    action={eventHandlers.enquireStatus}
                    label={complianceTranslationText.enquireStatus}
                  />
                )
              case SIUtils.Action.downloadPermit:
                  return (
                    <BookingActionMenuItem
                      icon={downloadIcon}
                      action={eventHandlers.onDownloadPermit}
                      label={complianceTranslationText.downloadPermit}
                      notFreeze={true}
                    />
                  )

              case SIUtils.Action.revoke:
                return (
                  <BookingActionMenuItem
                    icon={rejectIcon}
                    action={eventHandlers.revokeBL}
                    label={complianceTranslationText.revokeBL}
                  />
                )

              case SIUtils.Action.revokeIssuedBL:
                return (
                  <BookingActionMenuItem
                    icon={rejectIcon}
                    action={eventHandlers.revokeIssuedBL}
                    label={complianceTranslationText.revokeIssuedBL}
                  />
                )

              case SIUtils.Action.retract:
                return (
                  <BookingActionMenuItem
                    icon={rejectIcon}
                    action={eventHandlers.retractSI}
                    label={complianceTranslationText.retractSI}
                  />
                )

              default:
                return <div></div>
            }
          })}
        </Menu>
      )}
    </Box>
  )
}

export default ActionMenuSIList
